export function getFileCssClass(nomeLimpo) {
  if (["Abertura-empresa", "Alteracao-contratual"].includes(nomeLimpo)) return "style-bkg-word";
  if (["Constituicao-Contrato-Social", "Constituicao-Contrato-Social-Destino", "Constituicao-Contrato-Social-Origem", "Contrato-alteracao", "inscricao-municipal", "CNPJ", "inscricao-estadual", "inscricao-municipal-origem", "inscricao-municipal-destino", "Documento-certidao-conselho-classe"].includes(nomeLimpo)) return "style-bkg-pdf";
  return "style-bkg";
}

export function getFileIcon(nomeLimpo) {
  if (["Abertura-empresa", "Alteracao-contratual"].includes(nomeLimpo)) return "word";
  if (["Constituicao-Contrato-Social", "Constituicao-Contrato-Social-Destino", "Constituicao-Contrato-Social-Origem", "Contrato-alteracao", "CNPJ", "inscricao-municipal-origem", "inscricao-municipal-destino", "Documento-certidao-conselho-classe"].includes(nomeLimpo)) return "pdf";

  if (nomeLimpo === "inscricao-municipal") {
    return "im";
  }

  return null;
}

export function limparNomeArquivo(fileName) {
  // remove extensão
  let nomeSemExtensao = fileName.replace(/\.[^/.]+$/, "");

  // divide por "-"
  let partes = nomeSemExtensao.split("-");

  // remove timestamp inicial (primeira parte é só o epoch)
  partes.shift();

  // regras especiais:
  const nome = partes.join("-");

  if (nome.includes("CNPJ")) {
    return "CNPJ";
  }

  if (nome.includes("inscricao-estadual")) {
    return "inscricao-estadual";
  }

  if (nome.includes("inscricao-municipal-origem")) {
    return "inscricao-municipal-origem";
  }

  if (nome.includes("inscricao-municipal-destino")) {
    return "inscricao-municipal-destino";
  }

  // contrato alteração → remove últimos 3 (contador, OS, CNPJ)
  if (nome.startsWith("Contrato-alteracao")) {
    return partes.slice(0, -3).join("-");
  }

  // alteração contratual → remove últimos 3 (contador, OS, CNPJ)
  if (nome.startsWith("Alteracao-contratual")) {
    return partes.slice(0, -3).join("-");
  }

  // constituição → remove último (CNPJ)
  if (nome.startsWith("Constituicao-Contrato-Social")) {
    return partes.length > 3 ? partes.slice(0, -1).join("-") : partes.join("-");
  }

   if (nome.startsWith("Constituicao-Contrato-Social-Destino")) {
    return partes.length > 3 ? partes.slice(0, -1).join("-") : partes.join("-");
  }

  if (nome.startsWith("Constituicao-Contrato-Social-Origem")) {
    return partes.length > 3 ? partes.slice(0, -1).join("-") : partes.join("-");
  }

  if (nome.startsWith("Documento-certidao-conselho-classe")) {
    return partes.length > 3 ? partes.slice(0, -1).join("-") : partes.join("-");
  }

  // abertura empresa → pode ou não ter CNPJ → se tiver, remove
  if (nome.startsWith("Abertura-empresa")) {
    return partes.length > 2 ? partes.slice(0, -1).join("-") : partes.join("-");
  }


  // default
  return nome;
}

export function pegarContadorInterno(fileName, nomeLimpo) {
  if (!["Alteracao-contratual", "Contrato-alteracao"].includes(nomeLimpo)) return null;

  const nomeSemExtensao = fileName.replace(/\.[^/.]+$/, "");
  const partes = nomeSemExtensao.split("-");

  if (nomeLimpo === "Contrato-alteracao") {
    // Exemplo: ...-Contrato-alteracao-01-102047-23791830000180
    return partes[partes.length - 3]; // o "01"
  }

  if (nomeLimpo === "Alteracao-contratual") {
    // Exemplo: ...-Alteracao-contratual-01-23791830000180
    return partes[partes.length - 3]; // o "01"
  }

  return null;
}

export function pegarNumeroOS(fileName, nomeLimpo) {
  if (nomeLimpo !== "Contrato-alteracao") return null;

  const nomeSemExtensao = fileName.replace(/\.[^/.]+$/, "");
  const partes = nomeSemExtensao.split("-");

  // Exemplo: 1755607170148-Contrato-alteracao-01-102047-23791830000180
  // OS está antes do CNPJ → penúltima parte
  return partes[partes.length - 2];
}